export default __webpack_public_path__ + "static/media/sort-numeric-ascending-selected.6579205e.svg";